import script from "./competenzeList.vue?vue&type=script&setup=true&lang=js"
export * from "./competenzeList.vue?vue&type=script&setup=true&lang=js"

import "./competenzeList.vue?vue&type=style&index=0&id=13c665a4&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c665a4"]])

export default __exports__